import { render } from "./ProgressDoughnutChart.vue?vue&type=template&id=91ad01a4"
import script from "./ProgressDoughnutChart.vue?vue&type=script&lang=js"
export * from "./ProgressDoughnutChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__